import {ZapleczeApi} from "../../../ZapleczeApi.ts";
import Profile from "../../../Model/Profile.ts";
import {EpidStatus as EpidStatusModel} from "../model/EpidStatus.ts";


export class EpidStatus extends ZapleczeApi {

    constructor(token: string, profile: Profile) {
        super(token, profile);
    }

    public async allEpidStatus(): Promise<EpidStatusModel[]> {
        const url = this.getUrl() + '/api/v1/epid/status';
        try {
            return this.get<EpidStatusModel[]>(url);
        } catch (error) {
            console.error('Error fetching epid status:', error);
            throw error;
        }
    }
}

